module.exports = __webpack_public_path__ + "img/PORTUGUES.2f0c198f.png";